import { useMemo } from "react";
import { useMetadataQuery } from "@/entities/form-metadata";
import { type EventExactnessConfig, getEventExactnessConfig } from "./getEventExactnessConfig";

export type { EventExactnessConfig };

/** React binding for {@link getEventExactnessConfig}, memoized against the current form metadata. */
export const useEventFieldsWithExactnessDisabled = (): EventExactnessConfig => {
    const { data: formMetadata } = useMetadataQuery();

    return useMemo(() => getEventExactnessConfig(formMetadata), [formMetadata.fieldGroupsAndFeatureContainers]);
};
